import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { Route, RouterLinkComponent } from '@web/common';
import { UserInfoProviderService } from '@web/shared/module/auth';
import { PublicBoxQuestionnaireCounterService } from '@web/shared/module/shop';
import { Icon, IconComponent } from '@web/shared/ui';
import { combineLatest, map, Observable } from 'rxjs';
import { CounterBadgeComponent } from '../counter-badge/counter-badge.component';
import { Button } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';

@Component({
  selector: 'app-floating-box-questionnaire-link',
  imports: [
    AsyncPipe,
    IconComponent,
    CounterBadgeComponent,
    RouterLinkComponent,
    Button,
    Tooltip,
  ],
  templateUrl: './floating-box-questionnaire-link.component.html',
  styleUrl: './floating-box-questionnaire-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FloatingBoxQuestionnaireLinkComponent {
  private readonly userInfo = inject(UserInfoProviderService);
  private readonly questionnaireCounter = inject(
    PublicBoxQuestionnaireCounterService,
  );

  protected readonly Route = Route;
  protected readonly Icon = Icon;
  protected readonly closed = signal(false);
  protected readonly count$: Observable<number>;
  protected readonly isVisible$: Observable<boolean>;

  public constructor() {
    this.count$ = this.prepareCountSource();
    this.isVisible$ = this.prepareIsVisibleSource();
  }

  public handleCloseClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.closed.set(true);
  }

  private prepareIsVisibleSource(): Observable<boolean> {
    return combineLatest([this.userInfo.isLoggedIn(), this.count$]).pipe(
      map(([isLoggedIn, count]) => isLoggedIn && count > 0),
    );
  }

  private prepareCountSource(): Observable<number> {
    return this.questionnaireCounter.count$;
  }
}
